import React, { StrictMode, useEffect, useState } from 'react'
import { createRoot } from 'react-dom/client';

import 'bootstrap'

import './index.css'
import { HomePage } from './home_page'
import { SiteHeader } from './header'
import { ContactPage } from './contact'
import { PostsPage } from './posts'
import { HiddenPage } from './hidden'
import 'bootstrap/dist/css/bootstrap.min.css';


function Error404(){
  return (
    <div className="text-center container-md">
      <SiteHeader />
      <h1>Where am I?</h1>
      <p>(page not found)</p>
    </div>
  )
}

function pageForPath(pathname: string): string {
  const p = pathname.replace(/\/+$/, '') || '/'
  if (p === '/') return 'Home'
  if (p === '/posts') return 'Posts'
  if (p === '/contact') return 'Contact'
  if (p === '/hidden' || p.startsWith('/hidden/')) return 'Hidden'
  return 'Error404'
}

interface RenderProps {
  path: string;
  navigate: (to: string) => void;
}

function RenderPage(props: RenderProps){
  switch(pageForPath(props.path)){
    case 'Home':
      return <HomePage />;
    case 'Contact':
      return <ContactPage />;
    case 'Posts':
      return <PostsPage />;
    case 'Hidden':
      return <HiddenPage path={props.path} navigate={props.navigate} />;
    default:
      return <Error404 />;
  }
}

interface NavItemProps {
  active: boolean;
  disabled: boolean;
  href: string;
  navigate: (to: string) => void;
  value: string;
}

function NavItem(props: NavItemProps) {
  return (
    <li className="nav-item">
      <a
        className={`nav-link ${props.active === true ? 'active' : ''} ${props.disabled ? 'disabled' : ''}`}
        aria-current="page"
        href={props.href}
        onClick={(e) => { e.preventDefault(); props.navigate(props.href); }}
      >
        {props.value}
      </a>
    </li>
  );
}

interface NavBarProps {
  path: string;
  navigate: (to: string) => void;
}

function NavBar(props: NavBarProps){
  const navItems: Array<{ name: string; path: string; disabled?: boolean }> = [
    { name: "Home", path: "/" },
    { name: "Posts", path: "/posts" },
    { name: "Contact", path: "/contact" },
    { name: "Projects (soon)", path: "/", disabled: true },
  ]

  const page = pageForPath(props.path)

  const navList = navItems.map((i) =>
    <NavItem
      value={i.name}
      key={i.name}
      disabled={i.disabled || false}
      href={i.path}
      navigate={props.navigate}
      active={page === i.name}
    />
  )

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light">
      <div className="container-fluid">
        <a
          className="navbar-brand"
          href="/"
          onClick={(e) => { e.preventDefault(); props.navigate('/'); }}
        >
          justinMBurrous.com
        </a>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav">
            {navList}
          </ul>
        </div>
      </div>
    </nav>
  )
}

function App(){
  const [path, setPath] = useState(window.location.pathname)

  useEffect(() => {
    const onPop = () => setPath(window.location.pathname)
    window.addEventListener('popstate', onPop)
    return () => window.removeEventListener('popstate', onPop)
  }, [])

  const navigate = (to: string) => {
    window.history.pushState(null, '', to)
    setPath(to)
  }

  return (
    <div>
      <NavBar path={path} navigate={navigate} />
      <RenderPage path={path} navigate={navigate} />
    </div>
  )
}

const container = document.getElementById('root')!;
const root = createRoot(container);
root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
